import { render, staticRenderFns } from "./FHomeBusinessArea.vue?vue&type=template&id=07344067&scoped=true&"
import script from "./FHomeBusinessArea.vue?vue&type=script&lang=js&"
export * from "./FHomeBusinessArea.vue?vue&type=script&lang=js&"
import style0 from "./FHomeBusinessArea.vue?vue&type=style&index=0&id=07344067&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07344067",
  null
  
)

export default component.exports